import Loading from '@/components/Loading';

/** 中央配置のローディングスピナー */
export default function AdminLoadingState() {
  return (
    <div className="flex min-h-[360px] items-center justify-center">
      <Loading />
    </div>
  );
}
